import React, { useEffect, useState } from "react";
import defaultimg from "../../Assets/Images/uploadplus.png";
import { errorToast, successToast } from "../../Common/showtoast";
import ApiRequest, { baseurl } from "../../Common/restservice";
import { useNavigate } from "react-router-dom";
import { BiPencil, BiTrash } from "react-icons/bi";
import ImageWithFallback from "../../Components/ImageWithFallback";

function Portfolio({ stateObj, setStateObj, UpdateProfile }) {
  const navigate = useNavigate();
  const [photos, setPhotos] = useState([]);
  const [apiPhotos, setApiPhotos] = useState([]);
  const [photosLength, setphotosLength] = useState("");
  useEffect(() => {
    setphotosLength(photos.length + apiPhotos.length);
  }, [photos, apiPhotos]);

  useEffect(() => {
    GetMyProfile();
  }, []);
  const GetMyProfile = async (e) => {
    let res = await ApiRequest("getPortfolioImages.asp", "POST", {memberid:localStorage.getItem("username")}, {
      Authorization: localStorage.getItem("token"),
    });
    if (res.status === "error") {
      errorToast(res.message);
      setApiPhotos([]);
      if (res.message === "Token Expired") {
        localStorage.clear();
        return navigate("/login");
      }
      return;
    }
    setApiPhotos(res.items);
  };
  const DeleteImage = async (id) => {
    let res = await ApiRequest(
      "RemoveImagePortfolio.asp",
      "POST",
      { imageid: id },
      {
        Authorization: localStorage.getItem("token"),
      }
    );
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Token Expired") {
        localStorage.clear();
        return navigate("/login");
      }
      return;
    }
    successToast(res.message);
    GetMyProfile();
  };
  const Upload = async (id) => {
    if(photos.length <= 0){
        return errorToast("Please select atleast one image");
    }
    let obj = new FormData();
    for(let x in photos){
        obj.append("heading"+(parseInt(x)+1),photos[x].name);
        obj.append("profileimage"+(parseInt(x)+1),photos[x].profileimage);
    }
    console.log(obj);
    obj.append("token",localStorage.getItem("token"));
    let res = await ApiRequest(
      "uploadPortfolioImages.asp",
      "POST",
      obj,
      {
        Authorization: localStorage.getItem("token"),
      }
    );
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Token Expired") {
        localStorage.clear();
        return navigate("/login");
      }
      return;
    }
    successToast(res.message);
    setPhotos([]);
    GetMyProfile();
  };
  return (
    <div className="row">
      <h6 className="text-danger mb-5">*Please note upload only jpg or jpeg files not more than 2 MB.</h6>
      {apiPhotos.map((item) => {
        return (
          <div className="col-sm-3 col-md-3">
            <div className="form-group text-center" style={{
                border: "1px solid lightgray",
                borderRadius: 10,
                position: "relative",
                overflow: "hidden",
              }}>
              <ImageWithFallback src={baseurl + item.imageurl} style={{ height: 200 }} />
              <label
                className="btn btn-danger"
                style={{ position: "absolute", top: 0, right: 0 }}
                onClick={() => DeleteImage(item.imageid)}
              >
                <BiTrash />
              </label>
            </div>
          </div>
        );
      })}
      {photos.map((item, index) => {
        return (
          <div className="col-sm-3 col-md-3">
            <div
              className="form-group text-center"
              style={{
                border: "1px solid lightgray",
                borderRadius: 10,
                position: "relative",
                overflow: "hidden",
              }}
            >
              <img src={item.url} style={{ height: 200 }} alt="" />
              <div style={{ position: "absolute", top: 0, right: 0 }}>
                <label
                  htmlFor={"socialMedia" + index}
                  className="btn btn-primary"
                >
                  <BiPencil />
                </label>
              </div>
              <input
                type="file"
                accept="image/jpg,image/jpeg"
                id={"socialMedia" + index}
                hidden
                name="socialMedia"
                className="form-control"
                onChange={(e) => {
                  let file = e.target.files[0];
                  if (file) {
                    let obj = {
                      name: file.name,
                      url: URL.createObjectURL(file),
                      profileimage:file
                    };
                    const updatedItems = photos.map((photo, pindex) =>
                      pindex === index ? { ...photo, ...obj } : photo
                    );
                    setPhotos(updatedItems);
                  }
                }}
              />
            </div>
          </div>
        );
      })}
      {photosLength < 5 && (
        <div className="col-sm-3 col-md-3">
          <div className="form-group">
            <label htmlFor="socialMedia">
              <img src={defaultimg} style={{ height: 200 }} alt="default" />
            </label>
            <input
              type="file"
              accept="image/jpg,image/jpeg"
              id="socialMedia"
              hidden
              name="socialMedia"
              className="form-control"
              onChange={(e) => {
                let file = e.target.files[0];
                if (file) {
                  let obj = {
                    name: file.name,
                    url: URL.createObjectURL(file),
                    profileimage:file
                  };
                  setPhotos([...photos, obj]);
                }
              }}
            />
          </div>
        </div>
      )}

      {apiPhotos.length < 5 && (
        <div className="form-group">
          <button
            className="btn btn-primary "
            onClick={() => {
              Upload();
            }}
          >
            Submit
          </button>
        </div>
      )}
    </div>
  );
}

export default Portfolio;
